import React, { ReactElement, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import ClassType from '../../model/pripomienka/ClassType';
import defaultAddPripomienka from './component/data/defaultAddPripomienka';
import { useSuccessMessageContext } from '../../context/SuccessMessageContext';
import SaveAdminPripomienka from '../../model/pripomienka/SaveAdminPripomienka';
import { useClient } from '../../context/ClientStatusContext';
import { addPripomienkaAdmin } from '../../client/addPripomienkaClient';
import useFieldErrorMessages from '../useFieldErrorMessages';
import { SafeParameterSetter } from '../../types/SafeParameterSetter';
import routes from '../../routing/routes';
import CreateAndUpdatePripomienkaAdminComponent
  from './component/CreateAndUpdatePripomienkaAdminComponent';

interface Props {
  classType: ClassType;
}
const AddPripomienkaAdmin = ({
  classType,
}: Props): ReactElement => {
  const {
    type, year, index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();
  const navigate = useNavigate();
  const { displaySuccess } = useSuccessMessageContext();

  const [pripomienka, setPripomienka] = useState<SaveAdminPripomienka>(defaultAddPripomienka(classType));
  const { status, wrapClient } = useClient(addPripomienkaAdmin);

  const { clearFieldErrorMessage, getFieldErrorMessage } = useFieldErrorMessages();

  const updateField: SafeParameterSetter<SaveAdminPripomienka> = (fieldName, value) => {
    setPripomienka(prevState => ({ ...prevState, [fieldName]: value }));
    clearFieldErrorMessage(fieldName);
    if (fieldName === 'ine' || fieldName === 'odsek' || fieldName === 'paragraf'
      || fieldName === 'clanok' || fieldName === 'celyMaterial') {
      clearFieldErrorMessage('pripomienkaK');
    }
  };

  const handleSubmit = async (): Promise<void> => {
    await wrapClient(
      classType,
      type,
      year,
      index,
      pripomienka,
    );
    if (classType === ClassType.PRIPOMIENKA) {
      navigate(routes.pripomienky.list.withParams(type, year, index));
      displaySuccess('Pripomienka bola úspešne pridaná.');
    } else {
      navigate(routes.hromadnePripomienky.list.withParams(type, year, index));
      displaySuccess('Hromadná pripomienka bola úspešne pridaná.');
    }
  };
  return (
    <CreateAndUpdatePripomienkaAdminComponent
      classType={classType}
      pripomienka={pripomienka}
      onUpdateField={updateField}
      submitStatus={status}
      onSubmit={handleSubmit}
      getFieldErrorMessage={getFieldErrorMessage}
    />
  );
};

export default AddPripomienkaAdmin;
